import { ComponentType } from 'react';

import { UseBoundStore } from 'zustand/react';
import type { StoreApi } from 'zustand/vanilla';

import {
  BaseFeatureState,
  useAbilityOverrides,
} from '@cast/infrastructure-abilities';
import { AbilityOverrides } from './ability-overrides/AbilityOverrides';
import { useCustomOverrides } from './custom-overrides/custom-overrides-state';
import { CustomOverrides } from './custom-overrides/CustomOverrides';
import { useFeedbackToolbar } from './feedback-toolbar/feedback-toolbar-state';
import { FeedbackToolbar } from './feedback-toolbar/FeedbackToolbar';
import { OpTourRecorder, useOpTourRecorderState } from './op-tour-recorder';

type Feature = {
  title: string;
  component: ComponentType;
  useState: UseBoundStore<StoreApi<BaseFeatureState>>;
};

export const features: Feature[] = [
  {
    title: 'Abilities',
    component: AbilityOverrides,
    useState: useAbilityOverrides,
  },
  {
    title: 'Custom Overrides',
    component: CustomOverrides,
    useState: useCustomOverrides,
  },
  {
    title: 'OP Tour Recorder',
    component: OpTourRecorder,
    useState: useOpTourRecorderState as unknown as UseBoundStore<
      StoreApi<BaseFeatureState>
    >,
  },
  {
    title: 'Feedback Toolbar',
    component: FeedbackToolbar,
    useState: useFeedbackToolbar,
  },
];

export type FeatureKey = (typeof features)[number]['title'];
